export default __webpack_public_path__ + "images/android.f75269d3.svg";